import { render, staticRenderFns } from "./soilScreen.vue?vue&type=template&id=06a6f3c9&scoped=true&"
import script from "./soilScreen.vue?vue&type=script&lang=js&"
export * from "./soilScreen.vue?vue&type=script&lang=js&"
import style0 from "./soilScreen.vue?vue&type=style&index=0&id=06a6f3c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a6f3c9",
  null
  
)

export default component.exports